<template>
  <div class="crosshair-container ind-2">
    <crosshair-svg></crosshair-svg>
    <crosshair-svg></crosshair-svg>
    <crosshair-svg></crosshair-svg>
    <crosshair-svg></crosshair-svg>
  </div>
</template>

<script>
  import crosshair_svg from '../svg/crosshair'

  export default {
    components: {
      'crosshair-svg': crosshair_svg
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .crosshair-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    transition: all 0.75s;
    svg {
      position: absolute;
      &:nth-child(1) {
        top: 0;
        left: 0;
        transform: translate(-36px, -36px);
      }
      &:nth-child(2) {
        top: 0;
        right: 0;
        transform: translate(36px, -36px);
      }
      &:nth-child(3) {
        bottom: 0;
        left: 0;
        transform: translate(-36px, 36px);
      }
      &:nth-child(4) {
        bottom: 0;
        right: 0;
        transform: translate(36px, 36px);
      }
    }
    @media screen and (max-width: $sm-max) {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// crosshair_background.vue?2d6a8b80